module.exports = __webpack_public_path__ + "static/img/voice2_left.9af51a1b.png";